<template>
  <div>
    <v-row class="mb-12">
      <v-col cols="3" class="text-left d-flex align-center">
        <v-btn v-if="prevLink" :to="prevLink.to" text>
          <v-icon left>mdi-arrow-left</v-icon> {{ prevLink.label }}
        </v-btn>
      </v-col>
      <v-col cols="6" class="text-center">
        <h1 class="view-title text-center">{{ params.title }}</h1>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn v-if="nextLink" :to="nextLink.to" text>
          {{ nextLink.label }}
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <template v-if="photos.length">
      <portal to="main">
        <CoolLightBox
          :items="photos"
          :index="index"
          :slideshow="false"
          :useZoomBar="true"
          @close="index = null"
          thumbsPosition="bottom"
        />
      </portal>

      <v-row justify="center">
        <v-col v-for="(photo, i) in photos" :key="photo.src" cols="1">
          <v-card @click="index = i">
            <v-img :src="photo.src" class="white--text align-end">
              <canvas width="240" height="320"></canvas>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-row justify="center">
      <v-col :cols="cols">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="100"
          hide-default-footer
        >
          <template v-slot:[`item.photo`]="{ item }">
            {{ item.Név }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["params"],
  data: () => ({
    headers: [],
    items: [],
    photos: [],
    prevLink: false,
    nextLink: false,
    index: null,
  }),
  mounted() {
    this.loadGallery();
    this.findHeaderLinks();
    this.fillTable();
  },
  methods: {
    async loadGallery() {
      if (this.params.dir) {
        this.photos = require(`@/../public/static/img/${this.$store.state.screenNumber}/${this.params.dir}/_gallery.json`);
      }
    },
    async findHeaderLinks() {
      const screenContent = require(`@/../public/static/data/${this.$store.state.screenNumber}/index.json`); // eslint-disable-line
      const content = Object.entries(screenContent);
      for (let i = 0; i < content.length; i++) {
        if (!content[i][0].startsWith("/") || content[i][0] === "/") {
          continue;
        }

        if (content[i][0] === this.$route.path) {
          if (
            i &&
            content[i - 1][0].startsWith("/") &&
            content[i - 1][0] !== "/"
          ) {
            this.prevLink = {
              to: { path: content[i - 1][0] },
              label: content[i - 1][1].params.title,
            };
          }
          if (
            i < content.length - 1 &&
            content[i + 1][0].startsWith("/") &&
            content[i + 1][0] !== "/"
          ) {
            this.nextLink = {
              to: { path: content[i + 1][0] },
              label: content[i + 1][1].params.title,
            };
          }

          break;
        }
      }
    },
    async fillTable() {
      for (const [i, item] of this.params.items.entries()) {
        if (i === 0) {
          for (const header of item) {
            this.headers.push({
              text: header,
              sortable: true,
              align: "center",
              value: header,
            });
          }
        } else {
          const row = {};
          for (const [i, data] of item.entries()) {
            row[this.headers[i].value] = data;
          }
          this.items.push(row);
        }
      }
    }
  },
  computed: {
    cols() {
      let cols;
      switch (this.headers.length) {
        case 1:
          cols = 3;
          break;
        case 2:
          cols = 6;
          break;
        case 3:
          cols = 9;
          break;
        default:
          cols = 12;
      }
      return cols;
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-data-table {
  background: none !important;
}
</style>
